<div class="support-wrapper">
	<div class="support-header">
		<h2 class="support-header__title" data-test-id="support-form-title">Contact Us</h2>
		<button class="support-header__close-btn" (click)="close()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
	<div class="support-description" *ngIf="modalDescription">
		<p>{{ modalDescription }}</p>
	</div>
	<div class="support-form">
		<form [formGroup]="supportForm">
			<div class="form-inputs">
				<h4 class="input-label" data-test-id="support-form-product" *ngIf="!data.payload?.product">Product</h4>
				<div class="form-inputs__product" *ngIf="!data.payload?.product">
					<mat-form-field appearance="outline" floatLabel="never">
						<mat-select formControlName="productName">
							<mat-option *ngFor="let product of productItems" [value]="product">{{ product }} </mat-option>
						</mat-select>
						<mat-error class="error" *ngIf="supportForm.controls.productName.hasError('required')"
							>Field is required</mat-error
						>
					</mat-form-field>
				</div>
				<div class="form-inputs__severity" *ngIf="supportForm.get('severity')">
					<h4 class="input-label" data-test-id="support-form-severity">Severity</h4>
					<mat-form-field appearance="outline" floatLabel="never">
						<mat-select formControlName="severity">
							<mat-option *ngFor="let severityOption of severityOptions" [value]="severityOption">
								{{ severityOption }}
							</mat-option>
						</mat-select>
						<mat-error class="error" *ngIf="supportForm.controls.severity.hasError('required')">
							Field is required
						</mat-error>
					</mat-form-field>
				</div>
				<div class="form-inputs__subject">
					<h4 class="input-label" data-test-id="support-form-subject">Subject</h4>
					<mat-form-field appearance="outline" floatLabel="never">
						<input maxlength="1000" minlength="5" matInput formControlName="subject" />
						<mat-error class="error" *ngIf="supportForm.controls.subject.hasError('required')"
							>Field is Required</mat-error
						>
						<mat-error class="error" *ngIf="supportForm.controls.subject.hasError('minlength')"
							>Subject minimum length is 5 character</mat-error
						>
					</mat-form-field>
					<ng-container *ngIf="isLoading">
						<app-spinner style="position: relative; margin-left: 50%; z-index: 2"></app-spinner>
					</ng-container>
				</div>
				<div class="form-inputs__description">
					<h4 class="input-label" data-test-id="support-form-description">Description</h4>
					<mat-form-field appearance="outline" class="fill-container" floatLabel="never">
						<textarea
							maxlength="1000"
							minlength="5"
							matInput
							formControlName="description"
							rows="7"
							cols="40"
						></textarea>
						<mat-error class="error" *ngIf="supportForm.controls.description.hasError('required')"
							>Field is Required</mat-error
						>
						<mat-error class="error" *ngIf="supportForm.controls.description.hasError('minlength')">
							Description minimum length is 5 character</mat-error
						>
					</mat-form-field>
				</div>
			</div>
			<div class="support-form__actions-buttons" [style.margin-top]="isLoading ? '0px' : '16px'">
				<button mat-button (click)="close()" data-test-id="support-form-cancel-btn">Cancel</button>
				<button
					mat-raised-button
					color="primary"
					data-test-id="support-submit-btn"
					[disabled]="!supportForm.valid"
					(click)="submit()"
				>
					Send
				</button>
			</div>
		</form>
	</div>
</div>
